export default __webpack_public_path__ + "static/media/536.badaf4b8.jpg";